import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { TitleBar, evenRowColor } from '../common/theme';
import { toTime, toTimeType } from '../../Utils';
import DateSelectorComp from '../common/DateSelectorComp';

const MainStudentTableComp = ({pageState}) => {    

    const titleRow = <TitleBar>
        <Col  style={{textAlign: 'left'}} xs='4'><br/> Students </Col>
        <Col xs='2'>Time<br/>Spent</Col>
        <Col xs='2'>Activities<br/>Mastered</Col>
        <Col xs='2'>Questions<br/>Attempted</Col>
        <Col xs='2'><br/>Score</Col>
    </TitleBar>;

    return (
        <Container>
            <DateSelectorComp pageState={pageState}/> <br/>
            {titleRow}
            {pageState.processedStudentSummary.map((studentRec, i) => 
                <StudentRow key={i} index={i} studentState={studentRec} pageState={pageState}/>
            )}
            <br/>
        </Container>
    );
};

MainStudentTableComp.propTypes = {
    data: PropTypes.object
};

const StudentRow = ({pageState, studentState, index}) => {
    let {StudentID, Name, timeSpent, TimesMastered, QuestionsRight, QuestionsAttempted, score} = studentState;  

    const showProgramsComp = () => {
        let nextState = [...pageState.processedStudentSummary];
        let index = nextState.findIndex(el => el.StudentID === StudentID);
        nextState[index] = {...nextState[index], showPrograms: true};
        pageState.setProcessedStudentSummary(nextState);
        pageState.setSelectedStudent({id:StudentID, StudentID, name:Name});
    };
    
    const selectedStyle = () =>{
        let style = {cursor: 'pointer'};
        style['background'] = (index%2==0)?evenRowColor:'FFFFFF';
        return style;
    };

    return (
    <>
        <Row onClick={() => showProgramsComp()} style={selectedStyle()}>
            <Col xs='4' style={{color:'blue',textDecoration:'underline'}}> {Name}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{toTime(timeSpent)} {toTimeType(timeSpent)}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{TimesMastered}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{QuestionsRight} / {QuestionsAttempted}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{score}{score!=='--' && <>%</>}</Col>
        </Row>

    </>
    );
};

export default MainStudentTableComp;